import { Box, Flex, Heading } from '@chakra-ui/react';
import React from 'react';

import CreditFacilityMissing from './CreditFacilityMissing';
import { LogOutButton } from 'packages/sidebar/ui/LogOutButton';

const CreditFacilityMissingFallback = () => (
  <Box
    padding={{ base: '30px', lg: '50px 40px' }}
    margin="0 auto"
    width="100%"
    maxWidth="1600px"
  >
    <Box>
      <Flex justify="space-between" width="100%">
        <Heading marginBottom="70px" display="inline-block">
          No Credit Facility Found
        </Heading>
        <Box width="30%">
          <Flex justify="space-between" alignItems="center">
            <LogOutButton />
          </Flex>
        </Box>
      </Flex>
      <CreditFacilityMissing />
    </Box>
  </Box>
);

export default CreditFacilityMissingFallback;
